import React from 'react';
import FlightReportPDFDownload from './FlightReportPDFDownload';
import { PDFIcon } from 'custom/constants';
import { connect } from 'react-redux';
import http from 'utils/http';
import { discrepancySummary, ffmSummery, getHistory } from 'utils/flight';

class FlightReportPDFDownloadContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfModal: false,
      flightReportDetails: {
        note: [],
        discrepancy: [],
        flightInfo: [],
        manifestSummary: [],
        flightReport: [],
        statistics: [],
        manifest: [],
      },
      note: [],
      flightInfo: {},
      ctype: this.props?.ctype,
    };
  }
  componentDidMount() {
    if (this.props.flight) {
      this.setState({ flightInfo: this.props.flight }, () => {
        this.fetchHistory();
        this.fetchNotes();
        this.fetchFfmSummery();
        this.fetchDiscrepancy();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.flight) !== JSON.stringify(this.props.flight)) {
      this.setState({ flightInfo: this.props.flight }, () => {
        this.fetchHistory();
        this.fetchNotes();
        this.fetchFfmSummery();
        this.fetchDiscrepancy();
      });
    }
  }

  handleOpenPDF = () => {
    this.setState({ pdfModal: true, });
  };

  closeModalPDF = () => {
    this.setState({ pdfModal: false, });
  };

  updateFlightReportDetails = (newData, key) => {
    if (key) {
      if (JSON.stringify(newData) === JSON.stringify(this.state[key])) {
        return null; // No state update, so no re-render
      }
    }
    this.setState({ [key]: newData }, () => { });

  };

  fetchHistory = () => {
    if (!this.props?.flight?.id) return;
    http.get('change_log?type=Flight&flightId=' + this.props?.flight?.id)
      .then(async ({ data }) => {
        let newData = await getHistory(data);
        this.setState({ history: newData, });
      });
  };

  fetchNotes = () => {
    if (!this.props?.flight?.id) return;
    http.get(`/note/${this.props?.flight?.id}`)
      .then(response => {
        const { data } = response;
        if (data.status === 'success') {
          if (data.data && data.data.length > 0) {
            this.setState({ note: data.data });
          } else {
            this.setState({ note: [] });
          }
        }
      });
  };

  fetchFfmSummery = () => {
    const manifestSummary = ffmSummery('ALL', this.props?.ffm);
    this.setState({ manifestSummary: manifestSummary });
  };

  fetchDiscrepancy = () => {
    if (!this.props?.flight?.id) return;
    http.get('/discrepancy/' + this.props?.flight?.id)
      .then((response) => {
        if (response.data.data.length > 0) {
          this.setState({ discrepancy: response.data.data }, () => {
            const discrepancy = discrepancySummary('ALL',this.state.discrepancy);
            this.setState({ discrepancySummary: discrepancy });
          });
        }
      });
  };


  render() {
    return (
      <>
        {this.state.pdfModal &&
          <FlightReportPDFDownload
            pdfModal={this.state.pdfModal}
            printFunction={this.updateFlightReportDetails}
            flightReportDetails={this.state.flightReportDetails}
            onClose={this.closeModalPDF}
            flightInfo={this.state.flightInfo}
            note={this.state.note}
            discrepancy={this.state.discrepancy}
            products={this.state.products}
            manifest={this.state.manifest}
            history={this.state.history}
            statistics={this.props.statistics}
            flightReport={this.props.checklist}
            manifestSummary={this.state.manifestSummary}
            flightReportSummary={this.state.flightReportSummary}
            discrepancySummary={this.state.discrepancySummary}
            ctype={this.state.ctype}
            exclude_disc={this.props.exclude_disc}
            airlineLogo={this.props.airlineLogo}
            updatedisableFlightFields={this.props.updatedisableFlightFields}
            disableFlightFields={this.props.disableFlightFields}
            rowSelectionIds={this.props.rowSelectionIds}
          />
        }
        <PDFIcon title='Download File' onClick={this.handleOpenPDF} />
      </>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    flight: state.flight,
    ffm: state.ffm,
  };
};

export default connect(mapStateToProps, null)(FlightReportPDFDownloadContainer);